var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8637 3.8637C4.21517 3.51223 4.78502 3.51223 5.13649 3.8637L9.0001 7.72731L12.8637 3.8637C13.2152 3.51223 13.785 3.51223 14.1365 3.8637C14.488 4.21517 14.488 4.78502 14.1365 5.13649L10.2729 9.0001L14.1365 12.8637C14.488 13.2152 14.488 13.785 14.1365 14.1365C13.785 14.488 13.2152 14.488 12.8637 14.1365L9.0001 10.2729L5.13649 14.1365C4.78502 14.488 4.21517 14.488 3.8637 14.1365C3.51223 13.785 3.51223 13.2152 3.8637 12.8637L7.72731 9.0001L3.8637 5.13649C3.51223 4.78502 3.51223 4.21517 3.8637 3.8637Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6978843b54a21dd36b45fc2cc189fc13.svg";
export { ForwardRef as ReactComponent };